import { c } from "react/compiler-runtime";
import { useCache } from "@effektify/cache";
import { useCardData } from "@effektify/data-provider";
import { useState, useEffect } from "react";
import useLogger from "../useLogger.js";
import useVariables from "../useVariables.js";
const useCardState = config => {
  const $ = c(20);
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [shouldRender, setShouldRender] = useState(true);
  const logger = useLogger("card-state");
  const {
    variablesVersion,
    goalsVersion
  } = useCache();
  const {
    hasMetConditions
  } = useVariables();
  const {
    conditions
  } = config;
  const cardData = useCardData(config);
  let t0;
  if ($[0] !== conditions || $[1] !== hasMetConditions) {
    t0 = () => {
      if (conditions) {
        setShouldRender(hasMetConditions(conditions));
      }
    };
    $[0] = conditions;
    $[1] = hasMetConditions;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== conditions || $[4] !== goalsVersion || $[5] !== hasMetConditions || $[6] !== variablesVersion) {
    t1 = [conditions, hasMetConditions, variablesVersion, goalsVersion];
    $[3] = conditions;
    $[4] = goalsVersion;
    $[5] = hasMetConditions;
    $[6] = variablesVersion;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  useEffect(t0, t1);
  let t2;
  if ($[8] !== cardData || $[9] !== config.data?.sources || $[10] !== logger) {
    t2 = () => {
      const dataSources = Object.keys(cardData);
      const configSources = Object.values(config.data?.sources || {}).map(_temp);
      logger.debug(`Card data updated ${dataSources.join(", ")}`);
      if (cardData && dataSources.length > 0) {
        const allFetchedDataSources = Object.values(cardData).filter(_temp2);
        const isAllDataReady = configSources.length === allFetchedDataSources.length && allFetchedDataSources.length === dataSources.length;
        setIsLoading(!isAllDataReady);
        setData(prev => {
          const newData = {};
          Object.entries(cardData).forEach(t32 => {
            const [key, value] = t32;
            if (value.data) {
              newData[key] = value.data;
            }
          });
          if (JSON.stringify(prev) === JSON.stringify(newData)) {
            return prev;
          }
          return {
            ...prev,
            ...newData
          };
        });
      }
    };
    $[8] = cardData;
    $[9] = config.data?.sources;
    $[10] = logger;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  const t3 = config.data?.sources;
  let t4;
  if ($[12] !== cardData || $[13] !== logger || $[14] !== t3) {
    t4 = [cardData, t3, logger];
    $[12] = cardData;
    $[13] = logger;
    $[14] = t3;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  useEffect(t2, t4);
  let t5;
  if ($[16] !== data || $[17] !== isLoading || $[18] !== shouldRender) {
    t5 = {
      data,
      isLoading,
      shouldRender
    };
    $[16] = data;
    $[17] = isLoading;
    $[18] = shouldRender;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  return t5;
};
function _temp(source) {
  return source.source;
}
function _temp2(data_0) {
  return "isPending" in data_0 && !data_0.isPending && "isLoading" in data_0 && !data_0.isLoading;
}
export { useCardState as default };